













import { CONFIG_CONSTS, ROUTER_CONSTS } from 'playboard-core';

import { mapGetters } from 'vuex';

const packageJson = require('../package.json');

export default {
  name: 'app',
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instance: CONFIG_CONSTS.getters.currentInstance
    }),
    appStyle: function () {
      const style = {};
      if (!!this.instance && !!this.instance.colors) {
        style['--branding-color'] = this.instance.colors.branding;
        style['--on-branding-color'] = ((!!this.instance.colors.onBranding && this.instance.colors.onBranding) || 'white');
      }
      return style;
    }
  },
  data: function () {
    return {
      packageJson
    };
  },
  methods: {
    onLogin: function (success: boolean) {
      if (success) {
        this.$router.replace({
          ...this.$route,
          name: ROUTER_CONSTS.routes.home
        });
      }
    }
  }
};

